// ============================================================
// CLASS & STUDENT TYPES
// ============================================================

export type AvatarEmoji =
  | '🦁' | '🐯' | '🦊' | '🐧' | '🦅' | '🐬' | '🦋' | '🐸'
  | '🦄' | '🐺' | '🦉' | '🐙' | '🦈' | '🐲' | '🌟' | '🚀';

export interface Student {
  id: string;
  name: string;
  avatar: AvatarEmoji;
  xp: number;
  level: number;
  totalStars: number;
  joinedAt: number;   // unix timestamp
}

export interface ClassRoom {
  id: string;
  name: string;
  teacherId: string;
  createdAt: number;
  studentCount: number;
  coverColor: string; // hex color for the class card
}

// ---- XP / Level thresholds ----------------------------------

export const XP_THRESHOLDS: number[] = [
  0,    // Level 1
  100,  // Level 2
  250,  // Level 3
  500,  // Level 4
  850,  // Level 5
  1300, // Level 6
  1900, // Level 7
  2700, // Level 8
  3700, // Level 9
  5000, // Level 10
];

export function getLevelForXP(xp: number): number {
  let level = 1;
  for (let i = 0; i < XP_THRESHOLDS.length; i++) {
    if (xp >= XP_THRESHOLDS[i]) level = i + 1;
    else break;
  }
  return Math.min(level, XP_THRESHOLDS.length);
}

export function getXPForNextLevel(currentLevel: number): number {
  return XP_THRESHOLDS[currentLevel] ?? Infinity;
}

// ---- Star award event ---------------------------------------

export interface StarAwardEvent {
  studentId: string;
  studentName: string;
  stars: number;       // how many stars granted this event
  grantedBy: string;   // teacher uid
  timestamp: number;
}
